/* eslint-disable */
// Google Tag Manager initialization script provided by Jane marketing team
// Note that this approach was chosen to workaround content security policy issues that prevented
// the use of the <script> tag directly in the HTML file, which is the standard way to include GTM.
(function(w,d,s,l,i){
    w[l]=w[l]||[];
    w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;
    j.src='https://analytics.jane.app/gtm.js?id='+i+dl;
    f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-K5496WW2');